module.exports = __webpack_public_path__ + "static/applegates-coaches-cover-photo-7ed1601654c4c02a7893148c5e280a35.jpg";